/**
 * An address the app may open when the app did not write it itself: a push's
 * `link`, a parked notification tap, the page a sign-in returns to (ingo-f1,
 * 5 Oct 2026, after ingo-39's audit of react-router-dom: GHSA-2j2x-hqr9-3h42,
 * GHSA-wrjc-x8rr-h8h6).
 *
 * The value comes back unchanged when it is one of the app's own screens, and
 * null otherwise:
 * - exactly one leading `/`: to a browser `//host` and `/\host` are another
 *   site, and `https:`, `javascript:` or a bare word are not a path at all;
 * - no backslash, no space, no control character anywhere;
 * - no empty segment (`/driver//x`);
 * - when `screens` is given, the path (before `?` or `#`) is one of them or
 *   below one of them: `/driver` admits `/driver/offer/…`, not `/drivers`.
 *
 * The server's links are `/driver/home`, `/home`, `/driver/offer/<key>` and
 * `/live-tracking?delivery=<id>` (InGo `Modules/Push/Messages`).
 *
 * @param {unknown} value
 * @param {string[]} [screens]
 * @returns {string|null}
 */
export function inAppPath(value, screens) {
  if (typeof value !== 'string' || value.length > 512) return null;
  if (!/^\/[^/\\]/.test(value)) return null;
  // eslint-disable-next-line no-control-regex
  if (/[\\\s\u0000-\u001f\u007f]/.test(value)) return null;
  const path = value.split(/[?#]/, 1)[0];
  if (path.includes('//')) return null;
  if (screens && !screens.some((screen) => path === screen || path.startsWith(`${screen}/`))) return null;

  return value;
}
